import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './AppIcon';
import { supabase } from '../lib/supabase';

const DeactivateEmployeeModal = ({ isOpen, onClose, employee, onDeactivateSuccess }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');

  if (!isOpen || !employee) return null;

  const handleDeactivate = async () => {
    if (!reason.trim()) return;
    
    setLoading(true);
    try {
      const { error } = await supabase
        .from('profili')
        .update({
          attivo: false,
          deactivated_at: new Date().toISOString(),
          reason_deactivate: reason
        })
        .eq('id', employee.id);

      if (error) throw error;
      
      // Prikaz poruke o uspjehu
      alert(t('deactivate_modal.success_deactivate'));
      
      if (onDeactivateSuccess) onDeactivateSuccess();
      onClose();
    } catch (err) {
      console.error(t('deactivate_modal.error'), err);
      alert(t('deactivate_modal.error') + ": " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">
      <div className="bg-card w-full max-w-md rounded-3xl border border-destructive/20 shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Header sa upozorenjem */}
        <div className="p-6 border-b border-border bg-destructive/5 flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center text-destructive mb-4 shadow-inner">
            <Icon name="UserX" size={32} />
          </div>
          <h3 className="font-black text-xl text-foreground uppercase tracking-tight">
            {t('deactivate_modal.title')}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            {t('deactivate_modal.subtitle')}
          </p>
          <div className="mt-2 px-4 py-1 bg-muted rounded-full border border-border">
            <span className="font-bold text-foreground">
              {employee.nome} {employee.cognome}
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground ml-1">
              {t('deactivate_modal.reason_label')}
            </label>
            <textarea
              className="w-full bg-background border border-border rounded-2xl p-4 text-sm font-medium focus:ring-2 focus:ring-destructive/20 focus:border-destructive/40 outline-none transition-all resize-none min-h-[100px]"
              placeholder={t('deactivate_modal.placeholder')}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>

          <div className="bg-muted/30 p-4 rounded-2xl border border-border/50">
            <ul className="space-y-2">
              <li className="flex gap-2 text-[11px] text-muted-foreground">
                <Icon name="ShieldAlert" size={14} className="text-destructive shrink-0" />
                {t('deactivate_modal.warning_login')}
              </li>
              <li className="flex gap-2 text-[11px] text-muted-foreground">
                <Icon name="Database" size={14} className="text-destructive shrink-0" />
                {t('deactivate_modal.warning_data')}
              </li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 bg-muted/10 border-t border-border flex gap-3">
          <button 
            onClick={handleDeactivate}
            disabled={loading || !reason.trim()}
            className="flex-[2] flex items-center justify-center gap-2 px-6 py-3 bg-destructive text-destructive-foreground rounded-2xl font-black text-xs uppercase tracking-widest hover:opacity-90 transition-all shadow-lg shadow-destructive/20 disabled:opacity-30 disabled:grayscale"
          >
            {loading ? (
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <><Icon name="Trash2" size={16} /> {t('deactivate_modal.confirm_btn')}</>
            )}
          </button>
          
          <button 
            onClick={onClose}
            className="flex-1 px-6 py-3 bg-muted text-foreground rounded-2xl font-bold text-xs uppercase tracking-widest hover:bg-muted/80 transition-all border border-border"
          >
            {t('deactivate_modal.cancel_btn')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateEmployeeModal;